
import { reportHomeQueryParams } from "@/lib/queryParams/reportHomeQueryParams";
import { thgQueryParams } from "@/lib/queryParams/thgQueryParams";
import { AttachmentResponseModule } from "@/store/modules/attachment-response.store";
import { ConfigModule } from "@/store/modules/config";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class QueryParamsList extends Vue {
  get reportQueryParams() {
    return reportHomeQueryParams;
  }

  get thgQueryParams() {
    return thgQueryParams;
  }

  get isQueryParamsShowing() {
    return ConfigModule.debug;
  }

  get attachmentRequestToken() {
    return AttachmentResponseModule.attachmentRequestToken;
  }

  get attachmentRequestId() {
    return AttachmentResponseModule.attachmentRequestId;
  }
}
